import App from "./App";
import * as ReactDOMClient from "react-dom/client";
import { HashRouter, BrowserRouter } from "react-router-dom";
import { ThemeContextProvider } from "./components/Hooks/darkmode";
import store from "./redux/store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const container = document.getElementById("root")!;

const root = ReactDOMClient.createRoot(container).render(
  <ThemeContextProvider>
    <Provider store={store}>
      <BrowserRouter>
        <App />
        <ToastContainer theme="colored" />
      </BrowserRouter>
    </Provider>
  </ThemeContextProvider>
);
